document.addEventListener("DOMContentLoaded", () => {
    
    // Vertical Thumbs Slider Initialization
    checkGallery();

    const productSection = document.querySelector('.feature_product_new_version');
    if (!productSection) return;

    const addToCartBtn = productSection.querySelector('button[type="submit"][name="add"]');

    // Handle flavor selection and quantity updates
    productSection.addEventListener('click', (event) => {
        const flavorCard = event.target.closest('.flavour_cl');
        if (!flavorCard) return;

        const quantityInput = flavorCard.querySelector('.quantity__input');
        if (!quantityInput) return;

        const isQuantityControl = event.target.closest('quantity-input') || 
                                  event.target.closest('.quantity__button') || 
                                  event.target.closest('.quantity__input');

        if (!isQuantityControl) {
            flavorCard.classList.toggle('option-selected');
            quantityInput.value = flavorCard.classList.contains('option-selected') ? 1 : 0;

            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
            setTimeout(() => {
                const currentQuantity = parseInt(quantityInput.value, 10) || 0;
                
                if (currentQuantity > 0) {
                    flavorCard.classList.add('option-selected');
                } else {
                    flavorCard.classList.remove('option-selected');
                }
                
                updateAddToCartButton();
            }, 10);
        }

        function updateAddToCartButton() {
            if (!addToCartBtn) return;
            const selectedCount = productSection.querySelectorAll('.flavour_cl.option-selected').length;

            if (selectedCount > 0) {
                addToCartBtn.removeAttribute('disabled');
                addToCartBtn.classList.remove('disabled');
                
                const btnText = addToCartBtn.querySelector('span');
                if (btnText && (btnText.innerText.toLowerCase().includes('sold out') || btnText.innerText.toLowerCase().includes('0'))) {
                    btnText.innerText = 'Add to cart';
                }
            } else {
                addToCartBtn.setAttribute('disabled', 'disabled');
                addToCartBtn.classList.add('disabled');
            }
        }

        if (!isQuantityControl) {
            updateAddToCartButton();
        }
    });

    // Custom Subscription Widget Injection
    const checkIcon = '<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.1347 0.318823C10.3421 0.112073 10.618 -0.00223683 10.9043 3.31727e-05C11.1906 0.00230317 11.4649 0.120963 11.6692 0.330983C11.8736 0.541003 11.992 0.825943 11.9996 1.12569C12.0072 1.42543 11.9033 1.71653 11.7098 1.93756L5.83628 9.6305C5.73529 9.7444 5.61339 9.8358 5.47788 9.8993C5.34238 9.9627 5.19604 9.9969 5.04763 9.9998C4.89922 10.0027 4.75177 9.9742 4.61412 9.916C4.47646 9.8579 4.35141 9.7712 4.24646 9.6613L0.351391 5.58205C0.242921 5.4762 0.155921 5.34855 0.0955812 5.20672C0.0352312 5.06489 0.00279112 4.91178 0.000171123 4.75653C-0.00243888 4.60128 0.0248311 4.44707 0.0803511 4.30309C0.135881 4.15912 0.218531 4.02834 0.323371 3.91854C0.428211 3.80875 0.553091 3.72219 0.690561 3.66404C0.828031 3.60588 0.975281 3.57732 1.12352 3.58006C1.27176 3.5828 1.41796 3.61678 1.55338 3.67998C1.68881 3.74318 1.8107 3.83429 1.91177 3.94789L4.99426 7.1746L10.1067 0.352743L10.1347 0.318823Z" fill="#1D8B55"/></svg>';

    const customizeSubscriptionWidget = () => {
        if (!productSection) return;

        const autoDeliverOption = productSection.querySelector('.sls-option-container[data-selling-plan-group]');
        const oneTimeOption = productSection.querySelector('.sls-option-container:not([data-selling-plan-group])');

        // Process Subscription Option
        if (autoDeliverOption && !autoDeliverOption.classList.contains('custom-text-added')) {
            const nameContainer = autoDeliverOption.querySelector('.sls-selling-plan-group-options');
            
            if (nameContainer) {
                const subscriptionInfo = `
                    <div class="custom-sub-subtitle"> </div>
                    
                    <ul class="custom-benefits-list">
                        <li>${checkIcon} Pause or Cancel Anytime</li>
                        <li>${checkIcon} Free Shipping with 2 bags</li>
                        <li>${checkIcon} Easily Change Quantities</li>
                    </ul>
                `;
                
                nameContainer.insertAdjacentHTML('beforebegin', subscriptionInfo);
                autoDeliverOption.classList.add('custom-text-added');
            }
        }

        // Process One-Time Purchase Option
        if (oneTimeOption && !oneTimeOption.classList.contains('custom-text-added')) {
            const oneTimeNameContainer = oneTimeOption.querySelector('.sls-label-container');
            
            if (oneTimeNameContainer) {
                const oneTimeInfo = `
                    <div class="custom-sub-subtitle">Delivered once</div>
                `;
                
                oneTimeNameContainer.insertAdjacentHTML('beforeend', oneTimeInfo);
                oneTimeOption.classList.add('custom-text-added');
            }
        }
    };

    // Observer to monitor deep DOM changes until target elements are rendered
    const observer = new MutationObserver(() => {
        const currentSection = document.querySelector('.feature_product_new_version');
        
        if (currentSection) {
            //Widget
            const optionsReady = currentSection.querySelector('.sls-option-container');
            if (optionsReady) {
                customizeSubscriptionWidget();
            }
            //Slider
            fixSlickOnVisibility(currentSection);
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'] 
    });
});

window.addEventListener("resize", () => {

    checkGallery();

});

let sliderRefreshed = false;

function fixSlickOnVisibility(container) {
    const isVisible = window.getComputedStyle(container).display !== 'none';
    
    if (!isVisible) {
        sliderRefreshed = false;
        return;
    }

    if (isVisible && !sliderRefreshed) {
        const $sliders = $(container).find('.slick-slider');
        
        if ($sliders.length > 0) {
            $sliders.each(function() {
                $(this).slick('refresh');
            });
            
            sliderRefreshed = true;
        }
    }
}

function checkGallery() {
    const $nav = $('.feature_product_new_version .product-thumbnails.slider-nav');
    if(!$nav.length){
        $('.feature_product_new_version').addClass('no-thumbs');
    }
    if (window.innerWidth > 767) {
        setTimeout(() => {
            if ($nav.hasClass('slick-initialized')) {
                $nav.slick('slickSetOption', 'vertical', true, false);
                $nav.slick('slickSetOption', 'verticalSwiping', true, false);
                $nav.slick('refresh');
            }
        }, 500);
    }else{
        setTimeout(() => {
            if ($nav.hasClass('slick-initialized')) {
                $nav.slick('slickSetOption', 'vertical', false, false);
                $nav.slick('slickSetOption', 'verticalSwiping', false, false);
                $nav.slick('refresh');
            }
        }, 500);
    }
}